/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const CopyrightFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 5a5 5 0 1 0 4.29 7.57l-1.72-1.03a3 3 0 1 1 0-3.08l1.72-1.03A5 5 0 0 0 12 7" />
  </Icon>
);
